import PlaySVG from '@public/icons/play.svg';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import Video from '@/shared/components/shared/Video';
import { VideoShape } from '@/shared/lib/types';

export type FullscreenVideoSectionProps = {
    video: VideoShape;
    mobileVideo?: VideoShape;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    data: FullscreenVideoSectionProps;
};

function FullscreenVideoSection({ data, ...props }: Props) {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);

    const device = useMediaQueryDeviceStateValue();
    const isMobile = device.includes('mobile');

    const currentVideo = isMobile && data.mobileVideo ? data.mobileVideo : data.video;

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        videoRef.current?.play();
                    } else {
                        videoRef.current?.pause();
                    }
                });
            },
            { rootMargin: '100% 0% 100% 0%' },
        );

        if (wrapperRef.current) {
            observer.observe(wrapperRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        data.video.length > 0 && (
            <section
                ref={wrapperRef}
                className={classNames('fullscreen-video-section-wrapper js-header-theme-trigger', props.className)}
                data-theme="light"
                {...props}
            >
                <Video
                    ref={videoRef}
                    className="showreel-video"
                    autoPlay
                    muted
                    playsInline
                    loop
                    sources={currentVideo}
                />
            </section>
        )
    );
}

export default FullscreenVideoSection;
